var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482.333 358.4V119.467L275.399 0v91.733l81.068 46.934c3.2 2.132 3.2 6.4 0 7.467l-96 55.467c-3.2 2.132-6.4 1.066-8.534 0l-96-55.467c-3.2-1.067-3.2-6.4 0-7.467L237 91.733V0L29 119.467V358.4v-1.067 1.067l78.933-45.867v-93.867c0-3.2 4.267-5.332 6.4-4.266l96 55.467c3.2 2.133 4.267 4.267 4.267 7.467v110.932c0 3.2-4.267 5.335-6.4 4.267L127.134 345.6 48.2 391.467 255.133 512l206.934-119.467-78.934-45.867-81.066 46.935c-3.2 2.132-6.4 0-6.4-4.268V278.4c0-3.2 2.132-6.4 4.266-7.467l96.001-55.467c3.199-2.132 6.399 0 6.399 4.267V313.6l80 44.8z",
    fill: "#4c4c4c",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.133 512l206.934-119.467-78.934-45.867-81.066 46.935c-3.2 2.132-6.4 0-6.4-4.268V278.4c0-3.2 2.132-6.4 4.266-7.467l96.001-55.467c3.199-2.132 6.399 0 6.399 4.267V313.6l78.933 45.867v-240l-226.133 131.2V512z",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275.4 0v91.733l81.067 46.934c3.2 2.132 3.2 6.4 0 7.467l-96 55.467c-3.2 2.132-6.4 1.066-8.534 0l-96-55.467c-3.2-1.067-3.2-6.4 0-7.467L237 91.733V0L29 119.467l226.133 131.2 226.133-131.2L275.4 0z",
    fill: "gray",
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M209.267 393.6l-81.068-46.934-78.933 45.867L256.2 512V250.667L29 119.467V358.4v-1.067 1.067l78.933-45.867v-93.867c0-3.2 4.267-5.332 6.4-4.266l96 55.467c3.2 2.133 4.267 4.267 4.267 7.467v110.932c1.067 4.267-2.133 7.467-5.333 5.335z",
    fill: "#4c4c4c",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnity);
export default __webpack_public_path__ + "static/media/unity.86fd144bcc890fe1cd7e52a48862ca9d.svg";
export { ForwardRef as ReactComponent };